const {
  getSupportedLanguageCodes,
  getSupportedLocaleCodes,
  getSupportedLocaleCodesByLanguage,
  getMainLocaleCodes,
  getMainLocaleFromLanguage,
  getLanguageCodeByLocale,
  getLocaleName,
  getLocaleSpecificName,
  getBrowserLocale,
} = require('./locale')

const {
  getHostnameByLocale,
  getUrlByLocale,
  getDomainMap,
  getLocaleByDomain,
  getDesiredDomainByLanguage,
} = require('./domain')

module.exports = {
  getSupportedLanguageCodes,
  getSupportedLocaleCodes,
  getSupportedLocaleCodesByLanguage,
  getMainLocaleCodes,
  getMainLocaleFromLanguage,
  getLanguageCodeByLocale,
  getLocaleName,
  getLocaleSpecificName,
  getBrowserLocale,
  getHostnameByLocale,
  getUrlByLocale,
  getDomainMap,
  getLocaleByDomain,
  getDesiredDomainByLanguage,
}
